import * as z from "zod";
import { OC } from "../../utils";
import { ClientTrip } from "./schema";

export const tripContract = OC.router({
  get: OC.input(ClientTrip.Get).output(ClientTrip.Trip),
  getAll: OC.input(ClientTrip.GetAll).output(
    z.array(ClientTrip.Trip.omit({ agencyPublicKey: true })),
  ),
  getByIds: OC.input(ClientTrip.GetByIds).output(
    z.array(ClientTrip.Trip.omit({ agencyPublicKey: true })),
  ),
});
